import React from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";

export default function UserHomepage() {
  const location = useLocation();
  const formData = location.state?.formData || {};

  const { firstName, middleName, lastName } = formData;
  const fullName = [firstName, middleName, lastName].filter(Boolean).join(" ");

  // Example feed posts using signup data
  const posts = [
    {
      id: 1,
      user: fullName || "New User",
      content: `Welcome ${fullName || "to BrightWay"}! Explore learning paths and opportunities tailored for you.`,
      timestamp: "Just now",
    },
    {
      id: 2,
      user: "BrightWay Team",
      content: "Complete your profile to unlock personalized recommendations and opportunities.",
      timestamp: "2 hours ago",
    },
  ];

  return (
    <PageContainer>
      <Sidebar>
        <h2>Quick Links</h2>
        <ul>
          <li>Home</li>
          <li>Opportunities</li>
          <li>Challenges</li>
          <li>Messages</li>
          <li>Profile</li>
        </ul>
      </Sidebar>

      <FeedContainer>
        <FeedHeader>
          <h1>Welcome, {firstName || "User"}!</h1>
          <p>Discover posts, challenges, and opportunities tailored for you.</p>
        </FeedHeader>

        {posts.map((post) => (
          <PostCard key={post.id}>
            <PostHeader>
              <UserAvatar>{post.user[0]}</UserAvatar>
              <div>
                <strong>{post.user}</strong>
                <Timestamp>{post.timestamp}</Timestamp>
              </div>
            </PostHeader>
            <PostContent>{post.content}</PostContent>
            <PostActions>
              <button>Like</button>
              <button>Comment</button>
              <button>Share</button>
            </PostActions>
          </PostCard>
        ))}
      </FeedContainer>
    </PageContainer>
  );
}

// Styled Components
const PageContainer = styled.div`
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  gap: 2rem;
`;

const Sidebar = styled.div`
  width: 220px;
  h2 {
    margin-bottom: 1rem;
  }
  ul {
    list-style: none;
    padding: 0;
    li {
      padding: 0.5rem 0;
      cursor: pointer;
      &:hover {
        font-weight: bold;
      }
    }
  }
`;

const FeedContainer = styled.div`
  flex: 1;
`;

const FeedHeader = styled.div`
  margin-bottom: 2rem;
  h1 {
    margin-bottom: 0.25rem;
  }
  p {
    color: #555;
    margin: 0;
  }
`;

const PostCard = styled.div`
  background-color: #fff;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  box-shadow: 0px 2px 6px rgba(0,0,0,0.08);
  margin-bottom: 1.5rem;
`;

const PostHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

const UserAvatar = styled.div`
  width: 40px;
  height: 40px;
  background-color: #3b82f6;
  color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  margin-right: 0.75rem;
`;

const Timestamp = styled.div`
  font-size: 0.8rem;
  color: #888;
`;

const PostContent = styled.p`
  margin-bottom: 1rem;
`;

const PostActions = styled.div`
  display: flex;
  gap: 1rem;
  button {
    background: none;
    border: none;
    color: #3b82f6;
    cursor: pointer;
    font-weight: bold;
    &:hover {
      text-decoration: underline;
    }
  }
`;
